/** UI-локализация enum-значений со стороны клиента. */
import i18n from 'i18next'

export function tierLabel(t: string): string {
  return {
    FREE: i18n.t('schoolFormatters.tierFree'),
    SCHOOL: i18n.t('schoolFormatters.tierSchool'),
    REGION: i18n.t('schoolFormatters.tierRegion'),
  }[t] ?? t
}

export function roleLabel(role: string): string {
  return {
    TEACHER: i18n.t('schoolFormatters.roleTeacher'),
    VICE_PRINCIPAL: i18n.t('schoolFormatters.roleVicePrincipal'),
    PRINCIPAL: i18n.t('schoolFormatters.rolePrincipal'),
    IT_ADMIN: i18n.t('schoolFormatters.roleItAdmin'),
    ADMIN: i18n.t('schoolFormatters.roleAdmin'),
  }[role] ?? role
}

export function roleColor(role: string): string {
  if (role === 'PRINCIPAL') return 'bg-purple-100 text-purple-800'
  if (role === 'VICE_PRINCIPAL') return 'bg-blue-100 text-blue-800'
  if (role === 'IT_ADMIN' || role === 'ADMIN') return 'bg-red-100 text-red-800'
  return 'bg-gray-100 text-gray-700'
}
